<template>
<div :class="$style['handle']">
    <pt-sub-title title="确认已完成交付">
    </pt-sub-title>
    
    <pt-form-item label="上传PDF文件：" :labelWidth="labelWidth" :required="true">
      <wt-upload-file :action="uploadApi" :data="picture_params" :img-url="privateResourcesUrl" listType="text"
          v-model="form.attachments" data-vv-as="PDF文件" v-validate="'required'">
          <el-button size="small" type="primary">点击上传</el-button>
        </wt-upload-file>
    </pt-form-item>
    <pt-form-item label="报告快递单号：" :labelWidth="labelWidth" :required="true">
       <el-input placeholder="请填写报告快递单号" data-vv-as="报告快递单号" v-validate="'required'" v-model="form.expressId"></el-input>
    </pt-form-item>
    <pt-form-item label="备注：" :labelWidth="labelWidth">
      <el-input placeholder="请填写备注" v-model="form.comment" type="textarea"></el-input>
    </pt-form-item>
</div>
</template>
<script>
import {
  validate
} from 'utils/validate'
export default {
  name: 'delay-dialog',
  props: {
    billData: {
      type: Object,
      default: ()=>{}
    },
  },
  data () {
    return {
      labelWidth:'150px',
      form:{

      },
      options:[],
      reasonProps: {
        label: 'name',
        value: 'id'
      },
      uploadApi: this.$uploadApi,
      picture_params: {
        resourceName: 'report',
        objectId: this.billData.id || 0
      },
      privateResourcesUrl: this.$privateResourcesUrl,
    }
  },
  watch: {
   
  },
  methods: {
    formValidata () {
      return validate(this, this.form)
    }   
  }
}
</script>
<style module lang="less">
@import "~less/var";
.handle {
  :global {
    .el-input,
    // .el-textarea,
    .el-input__inner {
      max-width: 2.8rem;
    }
    .el-input--suffix .el-input__inner {
      min-width: 2.8rem;
    }
    
  }
}
</style>